export default __webpack_public_path__ + "static/media/imagemissing.50d61677.jpg";